import React from "react";

export const PageHeader = ({ title, description, actions, eyebrow }) => (
  <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
    <div>
      {eyebrow ? <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground mb-1">{eyebrow}</p> : null}
      <h1 className="text-2xl md:text-3xl font-semibold tracking-tight">{title}</h1>
      {description ? <p className="mt-1 text-sm md:text-base text-muted-foreground">{description}</p> : null}
    </div>
    {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
  </div>
);
